var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "promoBar", staticClass: "header-promo-bar", style: _vm.barStyles },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", {
            staticClass:
              "header-promo-bar__promo-content column small-12 large-6",
            domProps: { innerHTML: _vm._s(_vm.promoBarText) }
          }),
          _c(
            "div",
            { staticClass: "header-promo-bar__promo-account-content" },
            [
              _c(
                "a",
                {
                  staticClass: "header-promo-bar__account-link",
                  attrs: { href: _vm.userLink }
                },
                [
                  _c("icon", {
                    style: _vm.iconStyles,
                    attrs: { name: "circle", size: "12px" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.userLabel))])
                ],
                1
              ),
              _vm.loggedIn
                ? _c("span", {
                    staticClass: "header-promo-bar__account-link-divider"
                  })
                : _vm._e(),
              _vm.loggedIn
                ? _c(
                    "a",
                    {
                      staticClass: "header-promo-bar__account-link",
                      attrs: { href: _vm.wishListLink }
                    },
                    [
                      _c("icon", {
                        style: _vm.iconStyles,
                        attrs: { name: "circle", size: "12px" }
                      }),
                      _c("span", [_vm._v("Favorites")])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }